import React from "react";
import { useQuery } from "react-query";
import { Link, useParams } from "react-router-dom";

const PostDetails = () => {
  const { postID } = useParams();
  console.log(postID);

  const { isLoading, data } = useQuery(`${postID}`, () =>
    fetch(
      `https://cufeed.apis.bluespacejp.com/api/v1/blogPosts/${postID}`
    ).then((res) => res.json())
  );
  // https://cufeed.apis. bluespacejp.com/
  if (isLoading) {
    return (
      <div className="grid justify-items-center py-[250px]">
        <span className="loading loading-infinity loading-lg"></span>
      </div>
    );
  }

  console.log(isLoading);

  return (
    <div>
      <div className="card w-full px-[10px] bg-base-100 shadow-emerald-100 shadow-lg ">
        <div className="card-body">
          <h2 className="card-title">{data?.title}</h2>
          <p>By {data?.author}</p>
          <div className="card-actions justify-start">
            <h3 className="text-xl ">
              {data?.category} || {data?.sourceName}
            </h3>
          </div>
          <h3 className="font-semibold ">
            {data?.date} {data?.time}
          </h3>
          <figure>
            <img src={`${data?.image}`} alt={`${data?.title}`} />
          </figure>
          <p>{data?.description}</p>
        </div>
      </div>

      <div className="py-[20px] text-center px-2">
        <p>
          This content was published in "{data?.sourceName}" on {data?.date}.
        </p>

        <Link
          className="text-red-500 font-semibold "
          key={data?._id}
          to={`${data?.sourceLink}`}
        >
          Tap here to read in details.
        </Link>
      </div>
    </div>
  );
};

export default PostDetails;
